import React from 'react';

const Tools = ({ tool }) => {
    return (
        <div>
            <div>
                <ula>
                    <li className="text-center">{tool}</li>
                </ula>
            </div>
        </div>
    );
};

export default Tools;